
const aboutincredfin1 = {
    "About InCred Financial": [
        {
          question: "What is the business of InCred Financial Services Limited (IFSL)?",
          answer: "InCred Financial Services Limited is a Non-Banking Financial Corporation having segments such as Personal Loan, Student Loan, School Financing & LAP, Anchor & Escrow backed lending & Lending to Financial Institutions."
        },
        {
          question: "Who are the promoters of IFSL?",
          answer: "IFSL was founded by Mr. Bhupinder Singh (Founder & Group CEO) and is backed by marquee investors like KKR Singapore, Teacher’s retirement of Texas, Abu Dhabi Investment Authority, Moore Strategic Ventures and more."
        },
        {
          question: "Is IFSL Rated?",
          answer: "InCred Finance has a long-term rating of A+ by CRISIL & CARE with a stable Outlook."
        },
        {
          question: "What is the AUM of IFSL?",
          answer: "The AUM at the end of Dec’23 of IFSL is Rs. 7,941 Cr with the following split:" + "<br/>" +
          "Personal Loans: Rs. 3,561 Cr."+ "<br/>" +
          "Student Loans: Rs. 1,778 Cr."+ "<br/>" +
          "School Financing & LAP: Rs. 500 Cr."+ "<br/>" +
          "Anchor & Escrow backed lending: Rs. 1,466 Cr."+ "<br/>" +
          "Lending to Financial Institutions: Rs. 635 Cr."+ "<br/>"
        },
        {
          question: "What is the profitability of IFSL?",
          answer: "For 9MFY24 the PBT is Rs. 298 Cr. and for FY23 the PBT was Rs. 207 Cr."
        },
        {
          question: "What is the extent of Bad loans (NPAs) of IFSL?",
          answer: "The NPAs of IFSL as on Dec’23 are relatively low. GNPA: 2.6% NNPA : 1.2%"
        },
        {
          question: "How leveraged is IFSL? / What is the debt to equity Ratio of IFSL?",
          answer: "IFSL is leveraged 1.5 times as on Dec’23"
        },
        {
          question: "What is the Net Interest margin of IFSL?",
          answer: "IFSL operates at a healthy NIM of 10.7% (for 9MFY24)."
        },
        {
          question: "What is the Capital Adequacy ratio?",
          answer: "As on Dec’23, the CRAR is 34%."
        },
    ],
  }
  
  export default aboutincredfin1;